(function(){
  var body=document.body;
  var isHome=body&&body.classList.contains('template-index');
  var digitalGuideHandle='your-first-dog-walking-client';
  var isDigitalGuide=!!document.querySelector('[data-product-handle="'+digitalGuideHandle+'"]');

  if(isHome){
    var belowFoldSales=document.querySelector('.dw-home-sales');
    if(belowFoldSales){
      belowFoldSales.style.contentVisibility='auto';
      belowFoldSales.style.containIntrinsicSize='auto 1800px';
    }

    document.querySelectorAll('.footer-promotions,.site-footer').forEach(function(el){
      el.style.contentVisibility='auto';
      el.style.containIntrinsicSize='auto 900px';
    });
  }

  if(body&&window.AOS){
    var disabled=body.dataset.animate_sections==='false'&&body.dataset.animate_underlines==='false'&&body.dataset.animate_buttons==='false'&&body.dataset.animate_images==='false';
    if(disabled){
      var originalInit=window.AOS.init.bind(window.AOS);
      window.AOS.init=function(options){
        var opts=Object.assign({},options||{},{disable:true});
        return originalInit(opts);
      };
      window.AOS.refresh=function(){};
      window.AOS.refreshHard=function(){};
    }
  }

  if(isHome&&window.theme){
    var skipFirstThemeCall=function(name){
      if(Object.prototype.hasOwnProperty.call(theme,name)){return;}
      Object.defineProperty(theme,name,{
        configurable:true,
        get:function(){return undefined;},
        set:function(fn){
          Object.defineProperty(theme,name,{
            value:function(){},
            writable:true,
            configurable:true,
            enumerable:true
          });
        }
      });
    };

    skipFirstThemeCall('videoModal');
    skipFirstThemeCall('rteInit');
    skipFirstThemeCall('articleImages');
    skipFirstThemeCall('initQuickShop');
  }

  if(window.theme&&!Object.prototype.hasOwnProperty.call(theme,'CartDrawer')){
    Object.defineProperty(theme,'CartDrawer',{
      configurable:true,
      get:function(){return undefined;},
      set:function(Ctor){
        if(Ctor&&Ctor.prototype&&!Ctor.prototype.__dwLazyCart){
          Ctor.prototype.__dwLazyCart=true;
          Ctor.prototype.init=function(){
            this.cartForm=new theme.CartForm(this.form);
            this._dwCartSynced=false;
            var syncCart=function(){
              if(this._dwCartSynced||!this.cartForm){return;}
              this._dwCartSynced=true;
              this.cartForm.buildCart();
            }.bind(this);

            document.querySelectorAll('.js-drawer-open-cart').forEach(function(btn){
              btn.addEventListener('pointerenter',syncCart,{once:true,passive:true});
              btn.addEventListener('focus',syncCart,{once:true,passive:true});
              btn.addEventListener('touchstart',syncCart,{once:true,passive:true});
            });

            document.addEventListener('ajaxProduct:added',function(){
              this._dwCartSynced=true;
              this.cartForm.buildCart();
              this.open();
            }.bind(this));
            document.addEventListener('cart:open',function(){
              syncCart();
              this.open();
            }.bind(this));
            document.addEventListener('cart:close',this.close.bind(this));
          };
        }
        Object.defineProperty(theme,'CartDrawer',{
          value:Ctor,
          writable:true,
          configurable:true,
          enumerable:true
        });
      }
    });
  }

  function restoreExploreMoreLinks(){
    document.querySelectorAll('#CollectionSection .collection-description .enlarge-text section').forEach(function(section){
      var heading=section.querySelector('h2,h3');
      if(!heading||heading.textContent.trim().toLowerCase()!=='explore more'){return;}
      var link=section.querySelector('a[href="/collections/hypoallergenic-dog-food-uk"]');
      if(!link){return;}
      if(link.classList.contains('dw-range-choice-card')||link.querySelector('.dw-range-choice-title,.dw-range-choice-copy,.dw-range-choice-cta')){
        var plain=document.createElement('a');
        plain.href='/collections/hypoallergenic-dog-food-uk';
        plain.textContent='Hypoallergenic Dog Food';
        link.replaceWith(plain);
      }
    });
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',restoreExploreMoreLinks);
  }else{
    restoreExploreMoreLinks();
  }
  document.addEventListener('shopify:section:load',function(){setTimeout(restoreExploreMoreLinks,0);});

  function cleanDigitalGuidePhysicalMessaging(){
    isDigitalGuide=!!document.querySelector('[data-product-handle="'+digitalGuideHandle+'"]');
    if(!isDigitalGuide){return;}
    document.querySelectorAll('.dw-conversion-reassurance,.product-single__meta .product__policies,.product-single__meta .product-block--sales-point').forEach(function(el){el.remove();});
    document.querySelectorAll('.product-single__meta .product-block--tab').forEach(function(el){
      var text=(el.textContent||'').trim().toLowerCase();
      if(text.indexOf('shipping information')!==-1){el.remove();}
    });
  }

  function addConversionReassurance(){
    if(!body){return;}
    isDigitalGuide=!!document.querySelector('[data-product-handle="'+digitalGuideHandle+'"]');
    if(isDigitalGuide){return;}
    var isCollection=body.classList.contains('template-collection');
    var isProduct=body.classList.contains('template-product');
    if(!isCollection&&!isProduct){return;}
    if(document.querySelector('.dw-conversion-reassurance')){return;}

    if(!document.getElementById('dw-conversion-reassurance-style')){
      var style=document.createElement('style');
      style.id='dw-conversion-reassurance-style';
      style.textContent='.dw-conversion-reassurance{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:8px;margin:16px 0 22px;padding:12px;border:1px solid rgba(17,17,17,.13);border-radius:14px;background:#f4f1e9;color:#171717;font-size:13px;line-height:1.35;text-align:center}.dw-conversion-reassurance__item{padding:4px 8px}.dw-conversion-reassurance strong{font-weight:700}@media(max-width:749px){.dw-conversion-reassurance{grid-template-columns:1fr;gap:3px;margin:12px 0 18px;padding:10px 12px;text-align:left}.dw-conversion-reassurance__item{padding:3px 2px}}';
      document.head.appendChild(style);
    }

    var bar=document.createElement('div');
    bar.className='dw-conversion-reassurance';
    bar.setAttribute('aria-label','Shopping benefits');
    bar.innerHTML='<div class="dw-conversion-reassurance__item">🎁 <strong>10% off</strong> your first order</div><div class="dw-conversion-reassurance__item">🚚 Tracked UK delivery <strong>from £2.99</strong> — calculated by weight</div><div class="dw-conversion-reassurance__item">✓ <strong>Free UK delivery</strong> over £50</div>';

    if(isCollection){
      var collectionGrid=document.getElementById('CollectionAjaxResult');
      if(collectionGrid&&collectionGrid.parentNode){
        collectionGrid.parentNode.insertBefore(bar,collectionGrid);
        return;
      }
    }

    if(isProduct){
      var priceBlock=document.querySelector('.product-single__meta .product-block--price');
      if(priceBlock&&priceBlock.parentNode){
        priceBlock.parentNode.insertBefore(bar,priceBlock.nextSibling);
        return;
      }
      var productMeta=document.querySelector('.product-single__meta');
      if(productMeta){productMeta.insertBefore(bar,productMeta.firstChild);}
    }
  }

  function runProductEnhancements(){
    cleanDigitalGuidePhysicalMessaging();
    addConversionReassurance();
    cleanDigitalGuidePhysicalMessaging();
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',runProductEnhancements);
  }else{
    runProductEnhancements();
  }
  document.addEventListener('shopify:section:load',function(){setTimeout(runProductEnhancements,0);});

  if(body&&body.classList.contains('template-product')){
    var digitalObserver=new MutationObserver(function(){cleanDigitalGuidePhysicalMessaging();});
    digitalObserver.observe(document.documentElement,{childList:true,subtree:true});
    window.setTimeout(function(){digitalObserver.disconnect();cleanDigitalGuidePhysicalMessaging();},10000);
  }
})();